import { GridLineLayerSpecification } from '../chart-props';
import { VectorDrawFunction } from './type';

export const drawGridLinesLayer: VectorDrawFunction<GridLineLayerSpecification> = (pass, features, layer, xAxis, yAxis, featureState) => {
    for (const feature of features) {
        let color = layer.paint.lineColor;
        if (layer.paint.hoverColor && feature.id) {
            if (featureState?.[feature.id]?.hover) {
                color = layer.paint.hoverColor;
            }
        }

        if (feature.geometry.type === 'Point') {
            if (layer.layout.axis === 'x') {
                const x = xAxis.project(feature.geometry.coordinates[0], pass.viewState);
                pass.drawer.drawLine([x, pass.viewState.chartViewport.top], [x, pass.viewState.chartViewport.bottom], {
                    color: color,
                    style: layer.paint.lineStyle,
                    width: layer.paint.lineWidth
                });
            } else {
                const y = yAxis.project(feature.geometry.coordinates[1], pass.viewState);
                pass.drawer.drawLine([pass.viewState.chartViewport.left, y], [pass.viewState.chartViewport.right, y], {
                    color: color,
                    style: layer.paint.lineStyle,
                    width: layer.paint.lineWidth
                });
            }
        }
    }
};
